import { BridgeComponent, BridgeElement } from '@hotwired/hotwire-native-bridge'

// Bridge component that replaces the web submit button with a native button
// in the iOS nav bar (e.g. the "Add a product" modal).
//
// Rails side: place this controller on the <form>, with data-bridge--form-target="submit"
// on the existing submit button. The web button stays in the DOM (web fallback)
// but is visually hidden in the native app.
//
// Flow:
// 1. connect() sends { submitTitle } to iOS, with a callback.
// 2. The user taps the native button → iOS calls the callback → clicks the web button.
// 3. turbo:submit-start / turbo:submit-end disable/re-enable the native button
//    during the request, the way the web button natively would (data-disable-with).
//
// Replay: on a submit redirect happening inside a modal, connect fires during
// the native transition and never reaches the new screen (see
// ListyWebViewController on the iOS side). The native screen emits
// `native:appeared` when it appears: we then re-emit connect — idempotent,
// iOS re-poses the same buttons. Only once per instance ({ once: true }): the
// race only exists at page creation, subsequent appearances (returning from a
// pushed screen…) already find the buttons in place.
export default class extends BridgeComponent {
  static component = 'form'
  static targets = ['submit']

  connect() {
    super.connect()
    this.#sendConnect()
    this.pagePath = window.location.pathname
    // Only for the page this controller belongs to (see menu_controller).
    this.appearedHandler = () => { if (window.location.pathname === this.pagePath) this.#sendConnect() }
    window.addEventListener('native:appeared', this.appearedHandler, { once: true })
  }

  disconnect() {
    window.removeEventListener('native:appeared', this.appearedHandler)
    super.disconnect()
  }

  #sendConnect() {
    this.send('connect', { submitTitle: new BridgeElement(this.submitTarget).title }, () => {
      this.submitTarget.click()
    })
  }

  submitStart() {
    this.submitTarget.disabled = true
    this.send('submitDisabled')
  }

  submitEnd() {
    this.submitTarget.disabled = false
    this.send('submitEnabled')
  }
}
